import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadersModule } from '../headers/raksme.headerModule';
import { BreadcrumbModule } from 'angular-crumbs';
import { RouterModule } from '@angular/router';
import { FormsHeaderComponent } from './raksme.fheadersComponent';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



@NgModule({
  declarations: [
    FormsHeaderComponent
  ],
  imports: [
    CommonModule,
    HeadersModule,
    BreadcrumbModule,
    RouterModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    FormsHeaderComponent
  ]
})
export class FormsHeadersModule { }
